import useGetKeyByActivityId from '../providers/ActivityKeyer/useGetKeyByActivityId';

export default useGetKeyByActivityId;
